import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

// ⭐ STRICT COMMAND: Denver ALWAYS goes back to Colorado map
export const backRoute = "/map/colorado";

export default function Denver() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly (NO LOOPS)
  useEffect(() => {
    if (!window.__denverBackRouteSet) {
      window.__denverBackRouteSet = true;
      navigate(".", { replace: true, state: { backRoute } });
    }
  }, [navigate]);

  return (

    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Denver, Colorado</h1>

        <section className="travel-review">
          {/* LEFT COLUMN — TEXT */}
          <div className="travel-text">
            <h2>Discover Denver, Colorado</h2>

            <p>
              Denver was founded in 1858 during the Pike’s Peak Gold Rush, a time when prospectors were moving
               between booming mining towns like Leadville and the growing settlements along the Front Range.
                That early movement between the mountains and the plains is part of what shaped Denver into the 
                central hub it is today.
             </p>

            <p>
              With Denver International Airport bringing travelers from all over the world, and Union Station sitting 
              right in the heart of downtown, the city naturally becomes the starting point for most Colorado adventures. 
              It’s not a mountain town like Aspen or Vail, but it’s the place that connects everything. Whether you’re 
              flying in, taking the A‑Line to Union Station, or just passing through on your way to the Rockies, Denver 
              has a way of welcoming you before you even realize your trip has started.
             </p>

            <h3>🚗 Getting There</h3>

            <p>
  Heading to Denver? You’ve got plenty of ways to arrive — and each one offers its own kind of experience.
  Most travelers fly into Denver International Airport (DEN), one of the largest and busiest airports in the
  country, with nonstop flights from major cities across the U.S. and around the world.
</p>

<p>
  From the airport, getting into the city is easy. You can take the A‑Line train directly from DEN to Union
  Station in downtown Denver — a smooth 37‑minute ride that drops you right in the heart of the city. Union
  Station itself is a destination, with restaurants, shops, and a beautifully restored historic interior.
</p>

<p>
  Prefer to drive? Denver is well‑connected by major highways, including I‑25 running north–south and I‑70
  running east–west through the mountains. Whether you're arriving from the Front Range, the plains, or the
  high country, the drive into Denver offers wide‑open views and classic Colorado scenery.
</p>


            {/* 🌟 MY PERSONAL OBSERVATION */}
            <h3>🌟 My Personal Observation</h3>

            <ul>
   <li>
  <div className="place-block">
    <strong>Denver Botanic Gardens:</strong> One of Denver’s most beautiful and peaceful escapes — a place where every
    season feels alive. The gardens host rotating exhibitions, outdoor art installations, and special events that make
    each visit feel different. During the holidays, the entire space transforms into a glowing wonderland with its
    famous Blossoms of Light display — a Christmas tradition that’s absolutely magical. Inside, the Freyer–Newman
    Center adds even more to explore, with galleries featuring sculptures, paintings, and nature‑inspired art. There’s
    also a café and restaurant on site, making it easy to spend a full afternoon wandering, relaxing, and taking in the
    atmosphere.<br />
    <a
      href="https://www.google.com/maps?q=39.732105487692536,-104.96124028031656"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 Denver Botanic Gardens
    </a>
  </div>
</li>



           <li>
  <div className="place-block">
    <strong>16th Street Mall:</strong> When I first moved to Colorado years ago, the 16th Street Mall felt like another
    world — alive, loud, and full of personality. Street performers played piano on the sidewalks, singers filled the
    air with music, and you could hop on a bicycle carriage or even a horse‑drawn ride to explore the entire stretch.
    Every corner had a restaurant, and the whole street felt like a celebration. Over the years, the mall has also been
    home to some of Denver’s biggest annual events — Christmas parades, St. Patrick’s Day celebrations, cultural
    festivals, and seasonal activities that bring the street back to life with crowds, lights, and energy. Today, the
    area is undergoing a major transformation. Construction has changed the flow of the street, and the bike and horse
    rides are no longer permitted in the main corridor. The city is rebuilding the sidewalks, redesigning the layout,
    and giving the area a cleaner, more peaceful feel. The free MallRide bus still runs up and down the street, making
    it easy to explore without walking the entire length. Even with the changes, the walk is still beautiful — lined
    with shops, restaurants, and open spaces. I need to return at night to see how the atmosphere has evolved and
    whether the nightlife and energy that once defined this street begin to return.<br />
    <a
      href="https://www.google.com/maps?q=39.74871112053082, -104.99681267166595"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 16th Street Mall
    </a>
  </div>
</li>



   <li>
  <div className="place-block">
    <strong>Union Station:</strong> Even if you’re not planning to take a train trip or you didn’t arrive in Denver by
    rail, Union Station has a unique atmosphere that’s absolutely worth a visit. Originally built in 1881 and later
    rebuilt in 1914 after a fire, the station has been a central landmark in Denver for more than a century. Today it
    welcomes millions of visitors each year — travelers, locals, and people who simply come to enjoy the space. The
    building feels alive with restaurants, coffee shops, events, shows, and live music that fill the Great Hall with
    energy. It’s one of those places where you can sit, relax, people‑watch, and feel the pulse of the city all in one
    spot.<br />
    <a
      href="https://www.google.com/maps?q=39.75309393839799,-104.99997635520322"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 Denver Union Station
    </a>
  </div>
</li>


              
            </ul>

            {/* 🏔️ HIDDEN GEMS */}
           <h3>🏔️ Hidden Gems in Denver</h3>

<ul>
  <li>
    <div className="place-block">
      <strong>Larimer Square:</strong> A historic block filled with restaurants, cafés, boutiques, and string lights
      that make the street glow at night. One of Denver’s most charming and atmospheric spots.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>D&F Clock Tower (16th Street):</strong> An iconic Denver landmark offering guided tours with access to
      the upper floors and panoramic views. Visits require reservations, but the experience is unforgettable.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Civic Center Park:</strong> A grand urban park surrounded by Denver’s most important buildings — the
      State Capitol, City and County Building, and the Denver Art Museum. A popular spot for festivals, gatherings,
      and seasonal events.
    </div>
  </li>
</ul>


            {/* 🛏️ PLACES TO STAY */}
           <h3>🛏️ Places to Stay in Denver</h3>

<p>
  Denver offers a wide range of lodging options, from modern downtown hotels to historic boutique stays.
  These top‑ranked choices consistently earn strong reviews on Booking.com and Expedia:
</p>

<ul>
  <li>
    <div className="place-block">
      <strong>Sheraton Denver Downtown Hotel:</strong> I stayed here for New Year’s Eve and New Year’s Day — the view was
      amazing, and the hotel itself is beautiful. Still highly rated today, with very good reviews and a great central
      location. 
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Aloft Denver Downtown:</strong> I stayed here during Christmas to watch the parade — small but cozy, clean,
      and super convenient. Still excellent today, with strong ratings and a lively atmosphere. 
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Hyatt Centric Downtown Denver:</strong> Modern, stylish, and consistently rated excellent. Great location
      for walking to restaurants, shops, and attractions. 
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Hotel Teatro:</strong> A boutique hotel with historic charm and luxury touches. Guests love the service,
      comfort, and proximity to Denver’s top spots. 
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>The Oxford Hotel:</strong> One of Denver’s most iconic historic hotels — exceptional reviews, elegant
      interiors, and steps from Union Station. 
    </div>
  </li>
</ul>


            <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
                        <div className="affiliate-block">
                          <AffiliateExpedia />
                          <AffiliateBooking />
                          <AffiliateTrip />
                        </div>

            {/* 🎥 VIDEOS */}
            <h3>🎥 My Travel Videos</h3>

            <p>Here are some videos I took from Grottos Ice Cave and Ashcroft Ghost Town.</p>

        <p>
  <a
    href="https://youtu.be/RSnhcdGAU0Y?si=5Q1Px_bjFTcCx51U"
    target="_blank"
    rel="noopener noreferrer"
  >
    16th Street Mall
  </a>
</p>

</div>

{/* RIGHT COLUMN — IMAGES */}
<div className="travel-image-column">
  <a
    href="https://youtu.be/iJAH0aGrRnY?si=XHEViJpm1lTRMjPd"
    target="_blank"
    rel="noopener noreferrer"
    className="youtube-image-card"
  >
    <img
      src="/images/usa/colorado/denver/building.jpg"
      alt="Denver Drive Video"
    />
  </a>

  <a
    href="https://youtu.be/RSnhcdGAU0Y?si=5Q1Px_bjFTcCx51U"
    target="_blank"
    rel="noopener noreferrer"
    className="youtube-image-card"
  >
    <img
      src="/images/usa/colorado/denver/16street2.jpg"
      alt="The 16th Street Video"
    />
  </a>
 <img src="/images/usa/colorado/denver/unionstation.jpg" alt="Union Station" />
  <img src="/images/usa/colorado/denver/bg.jpg" alt="Botanic Garden" />
  <img src="/images/usa/colorado/denver/bg2.jpg" alt="Botanic Garden" />
  <img src="/images/usa/colorado/denver/b3.jpg" alt="Botanic Garden" />
  <img src="/images/usa/colorado/denver/16street.jpg" alt="The 16th Street" />
  <img src="/images/usa/colorado/denver/16street3.jpg" alt="The 16th Street" />
  <img src="/images/usa/colorado/denver/sign.jpg" alt="16th Street Sign" />
  <img src="/images/usa/colorado/denver/cdn.jpg" alt="Street During the Night" />
  <img src="/images/usa/colorado/denver/bgn.jpg" alt="Botanic Garden" />
 

  
</div>
</section>
</div>

{/* Centered email button */}
<div className="email-wrapper">
  <button className="email-link" onClick={() => setOpen(true)}>
    contact@thefindingspot.com
  </button>
</div>

{/* Popup */}
<ContactPopup isOpen={open} onClose={() => setOpen(false)} />

<Footer />
</>
);
}
